import { createContext, useContext } from "react"

export const RefetchItemsContext = createContext<() => void>(() => {})

RefetchItemsContext.displayName = "RefetchItemsContext"

export const useRefetchItems = () => {
  return useContext(RefetchItemsContext)
}
